$w.onReady(function () {

});

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function button119_click(event) {

    $w("#button119").style.color = "#FF7B00"
    $w("#button100").style.color = "#000000"
    $w("#button111").style.color = "#000000"
    $w("#button117").style.color = "#000000"
    $w("#button118").style.color = "#000000"
    $w("#slideshow1").changeSlide(0)
        .then((newSlide) => {

        });
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function button100_click(event) {
    $w("#button119").style.color = "#000000"
    $w("#button100").style.color = "#FF7B00"
    $w("#button111").style.color = "#000000"
    $w("#button117").style.color = "#000000"
    $w("#button118").style.color = "#000000"
    $w("#slideshow1").changeSlide(1)
        .then((newSlide) => {

        });
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function button111_click(event) {
    $w("#button119").style.color = "#000000"
    $w("#button100").style.color = "#000000"
    $w("#button111").style.color = "#FF7B00"
    $w("#button117").style.color = "#000000"
    $w("#button118").style.color = "#000000"
    $w("#slideshow1").changeSlide(2)
        .then((newSlide) => {

        });
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function button117_click(event) {
    $w("#button119").style.color = "#000000"
    $w("#button100").style.color = "#000000"
    $w("#button111").style.color = "#000000"
    $w("#button117").style.color = "#FF7B00"
    $w("#button118").style.color = "#000000"
    $w("#slideshow1").changeSlide(3)
        .then((newSlide) => {

        });
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function button118_click(event) {

    $w("#button119").style.color = "#000000"
    $w("#button100").style.color = "#000000"
    $w("#button111").style.color = "#000000"
    $w("#button117").style.color = "#000000"
    $w("#button118").style.color = "#FF7B00"
    $w("#slideshow1").changeSlide(4)
        .then((newSlide) => {

        });
}


